<template>
  <div
    class="card-body border rounded mb-4"
    :class="theme == 'light' ? 'bg-white' : 'border-info'"
  >
    <div class="row">
      <div class="col-sm-10 mb-1">
        <h5>
          <b><i class="bx bx-map-pin mr-1"></i> Malware Detection</b>
        </h5>
      </div>
      <div class="col-sm-2 mb-2 text-right pl-1">
        <div class="row px-3">
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="malwareReportInterval"
            @change="getMalwareReports"
          >
            <option value="7d">{{ $t("malware.last-7") }}</option>
            <option value="30d">{{ $t("malware.last-30") }}</option>
            <option value="3m">{{ $t("malware.last-90") }}</option>
            <!-- <option value="1y">1 {{ $t("dashboards.year") }}</option> -->
          </select>
        </div>
      </div>
    </div>
    <GmapMap
      ref="mymap"
      :center="center"
      :zoom="zoom"
      class="maps"
      @click="measureDistance"
      :options="mapTheme()"
    >
      <div ref="custom" class="mr-2">
        <button
          title="Measure Distance"
          class="btn btn-white btn-sm py-2 mb-2"
          :class="measure_distance == true ? 'bg-info' : 'bg-white'"
          @click="distanceMode()"
        >
          <img
            src="https://img.icons8.com/external-those-icons-lineal-color-those-icons/24/000000/external-distance-maps-and-locations-those-icons-lineal-color-those-icons-2.png"
          />
        </button>
        <br />
        <button
          title="Point of Interest"
          class="btn btn-white btn-sm py-2 bg-white"
          @click="poiView()"
        >
          <img
            :src="
              poi == true
                ? 'https://img.icons8.com/glyph-neue/24/24991f/point-of-interest.png'
                : 'https://img.icons8.com/glyph-neue/24/525252/point-of-interest.png'
            "
          />
        </button>
      </div>

      <GmapMarker
        v-if="firstpoint.on == true"
        ref="first_point"
        :label="{
          text: '0 km',
          color: theme == 'dark' ? '#e5e7eb' : '#000000',
          fontWeight: 'bold',
        }"
        :clickable="true"
        :options="{
          position: {
            lat: parseFloat(firstpoint.lat),
            lng: parseFloat(firstpoint.lng),
          },
        }"
        :icon="{
          url:
            theme == 'dark'
              ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
              : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
          width: 50,
          height: 50,
          textSize: 12,
          anchor: { x: 14, y: 16 },
          labelOrigin: { x: 5, y: -5 },
        }"
        @click="unsetDistanceMarker('first')"
      />

      <GmapMarker
        v-if="secondpoint.on == true"
        ref="second_point"
        :label="{
          text: distance + ' km',
          color: theme == 'dark' ? '#e5e7eb' : '#000000',
          fontWeight: 'bold',
        }"
        :clickable="true"
        :options="{
          position: {
            lat: parseFloat(secondpoint.lat),
            lng: parseFloat(secondpoint.lng),
          },
        }"
        :icon="{
          url:
            theme == 'dark'
              ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
              : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
          width: 50,
          height: 50,
          textSize: 12,
          anchor: { x: 16, y: 16 },
          labelOrigin: { x: 5, y: -5 },
        }"
        @click="unsetDistanceMarker('second')"
      />

      <GmapPolyline
        v-if="firstpoint.on == true && secondpoint.on == true"
        :options="{
          strokeColor: theme == 'dark' ? '#9ca3af' : '#212121',
          strokeOpacity: 0.8,
          strokeWeight: 3,
        }"
        :path="[
          { lat: firstpoint.lat, lng: firstpoint.lng },
          { lat: secondpoint.lat, lng: secondpoint.lng },
        ]"
        :editable="false"
      />

      <GmapMarker
        v-for="(mp, index) in detection"
        :key="index"
        :clickable="true"
        :options="{
          position: {
            lat: parseFloat(mp.position.lat),
            lng: parseFloat(mp.position.lng),
          },
        }"
        :icon="{
          url: require('@/assets/images/dot-point.png'),
          width: 500,
          height: 500,
          textSize: 12,
          anchor: { x: 16, y: 16 },
          labelOrigin: { x: 5, y: -5 },
        }"
        @click="
          openMarker(
            index + 1,
            parseFloat(mp.position.lat),
            parseFloat(mp.position.lng),
            20
          )
        "
      >
        <gmap-info-window
          :closeclick="true"
          @closeclick="
            openMarker(
              null,
              parseFloat(mp.position.lat),
              parseFloat(mp.position.lng),
              15
            )
          "
          :opened="openMarkerId === index + 1"
        >
          <div class="p-2">
            <h4 class="text-success">
              {{ mp.country }}
            </h4>
            <div class="text-info border border-danger p-1 rounded">
              <h6 class="text-black mt-2 mx-2">Hits : {{ mp.hits }}</h6>
            </div>
          </div>
        </gmap-info-window>
      </GmapMarker>

      <!-- <GmapPolyline
        v-if="result_tracking[0]"
        :options="{
          strokeColor: theme == 'dark' ? '#9ca3af' : '#212121',
          strokeOpacity: 0.8,
          strokeWeight: 3,
        }"
        :path="path"
        :editable="false"
      /> -->

      <!-- <GmapMarker
        v-for="(track, index) in trackerpoint"
        :key="track.id"
        :label="{
          text: String(index + 1),
          color: theme == 'dark' ? '#e5e7eb' : '#e5e7eb',
          fontWeight: 'bold',
        }"
        :clickable="true"
        :options="{
          position: { lat: parseFloat(track.lat), lng: parseFloat(track.lng) },
        }"
        :icon="{
          url:
            theme == 'dark'
              ? 'https://img.icons8.com/ios-filled/50/991b1b/street-view.png'
              : 'https://img.icons8.com/ios-filled/50/EF4444/street-view.png',
          textSize: 12,
          anchor: { x: 25, y: 45 },
          labelOrigin: { x: 25, y: 22 },
        }"
        @click="openMarker(track.id)"
      >
      </GmapMarker> -->
    </GmapMap>
  </div>
</template>

<script>
import moment from "moment";
import ElasticService from "@/helpers/elastic.service";
import PreferencesServices from "@/helpers/preferences.service";
import StatisticsService from "@/helpers/statistics.service";
import { userService } from "@/helpers/authservice/user.service";

export default {
  data() {
    let clusterStyles = [
      {
        url: "/static/rec50.png",
        width: 50,
        height: 50,
        textSize: 12,
        textColor: "#fff",
        anchorText: [19, 0],
      },
    ];

    return {
      theme: localStorage.getItem("theme"),
      id: this.$route.params.id,
      malwareReportInterval: "7d",
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      user_type: "",
      agent: "",
      tableData: "",
      daterange: "",
      last_update: "",
      loading_tracking: false,
      result_tracking: [],
      currentPlace: [],
      openMarkerId: "",
      markers: [],
      places: [],
      startLocation: null,
      endLocation: null,
      title: this.$t("agen-detail.agent-location"),
      items: [
        {
          text: this.$t("menuitems.dashboards.text"),
          href: "/",
        },
        {
          text: this.$t("user-management.agen-management"),
          href: "/agent-management",
        },
        {
          text: this.$t("agen-detail.agent-location"),
          active: true,
        },
      ],
      markers: [
        {
          position: { lat: -7.783992353559322, lng: 110.37170620265111 },
        },
        {
          position: { lat: -7.77062298441253, lng: 110.46041339623409 },
        },
      ],
      detection: [],
      maploc: [],
      region: "",
      regions: [],
      openedMarkerID: null,
      clusterIcon: clusterStyles,
      track_location: true,
      path: [],
      drawpath: false,
      measure_distance: false,
      distance: "",
      poi: false,
      firstpoint: {
        on: false,
        lat: 0,
        lng: 0,
      },
      secondpoint: {
        on: false,
        lat: 0,
        lng: 0,
      },
      start_point: {
        lat: 0,
        lng: 0,
      },
      end_point: {
        lat: 0,
        lng: 0,
      },
      trackerpoint: [],
      center: { lat: 20.9853296, lng: 15.439878 },
      zoom: 2.4,
      line1: [],
    };
  },
  methods: {
    setPlaceStart(place) {
      // console.log("gas start");
      //   this.currentPlace = place;
      const marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.startLocation = marker;
    },

    openMarker(id, lat, lng, zoom) {
      // console.log("id", id);
      this.openMarkerId = id;
      // this.center = {lat : parseFloat(lat), lng : parseFloat(lng)};
      // this.zoom = zoom
    },

    setPlaceEnd(place) {
      // console.log("gas start");
      //   this.currentPlace = place;
      const marker = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.endLocation = marker;
    },

    getDetectionMalware() {
      let ferr = 0;
      if (this.malwareReportInterval == "7d") {
        var interval_detection = "20190301";
      } else if (this.malwareReportInterval == "30d") {
        var interval_detection = "20190501";
      } else if (this.malwareReportInterval == "3m") {
        var interval_detection = "20190515";
      }

      const params = {
        date: interval_detection,
      };
      // console.log("params detection", params);
      StatisticsService.getMalwareDetection(params)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getDetectionMalware();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.detection = [];
            const res = response.data.data.malware_detection[0];
            // console.log("res detection", res);
            res.forEach((val, index) => {
              const data = {
                no: index + 1,
                position: { lat: val.latitude, lng: val.longitude },
                country: val.country,
                hits: val.hits,
              };
              this.detection.push(data);
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getDetectionMalware();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    selectRegion(id) {
      // this.loading = true;
      this.region = id;
      console.log("mulai", id);
      this.$refs.dropdown.hide();
      AgenService.getAllAgent()
        .then((response) => {
          this.tableData = [];
          // console.log(response.data.data);
          response.data.data.forEach((val) => {
            const data = {
              id_agent: val.id_agent,
              nik: val.nik,
              address: val.address,
              birth_date: val.birth_date,
              agent_location: val.agent_location,
              agent_status: val.agent_status,
              is_ready: val.is_ready,
              is_in_case: val.is_in_case,
              auto_recieve: val.auto_recieve,
              device_name: val.device_name,
              device_token: val.device_token,
              id_region: val.id_region,
              account: val.account,
              region: val.region,
              created_at: this.formatDate(val.created_at),
              updated_at: this.formatDate(val.updated_at),
            };
            if (val.id_region == id) {
              this.tableData.push(data);
            }
            this.loading = false;
          });
          this.Tracking(id);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    mapTheme() {
      let darkMode = {
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      };

      let lightMode = {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
        ],
      };

      if (this.theme != "dark") {
        return lightMode;
      } else {
        return darkMode;
      }
    },

    measureDistance(event) {
      if (this.measure_distance == true) {
        this.setDistanceMarker(event.latLng.lat(), event.latLng.lng());
      } else {
        // console.log("Normal Mode");
      }
    },

    getDistance() {
      const latA = parseFloat(this.firstpoint.lat);
      const lngA = parseFloat(this.firstpoint.lng);
      const latB = parseFloat(this.secondpoint.lat);
      const lngB = parseFloat(this.secondpoint.lng);
      let d = (
        google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(latA, lngA),
          new google.maps.LatLng(latB, lngB)
        ) / 1000
      ).toFixed(2);

      this.distance = d;
    },

    setDistanceMarker(lat, lng) {
      if (this.firstpoint.on == false) {
        this.firstpoint.on = true;
        this.firstpoint.lat = lat;
        this.firstpoint.lng = lng;
      } else if (this.secondpoint.on == false) {
        this.secondpoint.on = true;
        this.secondpoint.lat = lat;
        this.secondpoint.lng = lng;
      } else {
        this.resetDistanceMarker();
      }

      this.getDistance();
    },

    unsetDistanceMarker(point) {
      if (point == "first") {
        this.firstpoint.on = false;
        this.firstpoint.lat = 0;
        this.firstpoint.lng = 0;
      } else if (point == "second") {
        this.secondpoint.on = false;
        this.secondpoint.lat = 0;
        this.secondpoint.lng = 0;
      }
    },

    resetDistanceMarker() {
      this.firstpoint.on = false;
      this.firstpoint.lat = 0;
      this.firstpoint.lng = 0;
      this.secondpoint.on = false;
      this.secondpoint.lat = 0;
      this.secondpoint.lng = 0;
    },

    distanceMode() {
      if (this.measure_distance == true) {
        this.measure_distance = false;
        this.resetDistanceMarker();
      } else {
        this.measure_distance = true;
      }
    },

    poiView() {
      if (this.poi == true) {
        this.poi = false;
        console.log("poi->", this.poi);
      } else {
        this.poi = true;
        console.log("poi->", this.poi);
      }
    },

    sorting(arr) {
      return arr.slice().sort(function (a, b) {
        return a.id - b.id;
      });
    },

    Tracking(id) {
      this.loading_tracking = true;
      this.result_tracking = [];
      this.trackerpoint = [];
      // console.log("tracking", id);
      AgenService.getAllAgent()
        .then((response) => {
          // console.log(id_region, response.data.data);
          let agent = response.data.data;
          if (!id) {
            agent.forEach((val) => {
              if (val.agent_location) {
                let location = val.agent_location.split(",");
                let lat = location[0];
                let long = location[1];
                this.setTrackerPoint(
                  val.id_agent,
                  lat,
                  long,
                  val.updated_at,
                  val.account
                );
              } else {
                this.setTrackerPoint(val.id_agent, "", "", val.updated_at, "");
              }
            });
          } else {
            agent.forEach((val) => {
              if (val.agent_location) {
                console.log(val);
                if (val.id_region == id) {
                  let location = val.agent_location.split(",");
                  let lat = location[0];
                  let long = location[1];
                  this.setTrackerPoint(
                    val.id_agent,
                    lat,
                    long,
                    val.updated_at,
                    val.account
                  );
                }
              } else {
                this.setTrackerPoint(val.id_agent, "", "", val.updated_at, "");
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading_tracking = false;
        });
    },

    // openMarker(id) {
    //   this.openedMarkerID = id;
    // },

    trafficMode() {
      this.$refs.mymap.$mapPromise.then((map) => {
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);
      });
    },

    setCheck(id) {
      for (let i = 0; i < this.line1.length; i++) {
        if (id == this.line1[i].id) {
          return true;
        }
      }
      return false;
    },

    setTrackerPoint(id, lat, lng, date, account) {
      let data = {
        id: id,
        lat: lat,
        lng: lng,
        account: account,
        date: date,
      };
      // console.log(data);
      this.$refs.mymap.$mapPromise.then((map) => {
        if (this.trackerpoint.length == 0) {
          // console.log('ifff');
          this.trackerpoint.push(data);
          this.path.push({ lat: parseFloat(lat), lng: parseFloat(lng) });
          this.center = { lat: parseFloat(lat), lng: parseFloat(lng) };
          this.zoom = 7;
          this.line1.push({
            id: id,
          });
        } else {
          // console.log('else');
          if (this.checkTrackerPoint(id) == "unchecked") {
            this.trackerpoint.push(data);
            this.path.push({ lat: parseFloat(lat), lng: parseFloat(lng) });
            this.center = { lat: parseFloat(lat), lng: parseFloat(lng) };
            this.zoom = 7;
            this.line1.push({
              id: id,
            });
          } else if (this.checkTrackerPoint(id) == "checked") {
            let indexpoint = "";
            let indexpath = "";
            this.trackerpoint.map(function (val, index) {
              if (val.id == id) {
                indexpoint = index;
              }
            });
            this.path.map(function (val, index) {
              if (parseFloat(val.lat) == parseFloat(lat)) {
                indexpath = index;
              }
            });
            this.trackerpoint.splice(indexpoint, 1);
            this.path.splice(indexpath, 1);
            this.zoom = 7;
            for (let i = 0; i < this.line1.length; i++) {
              this.line1[i].path.setMap(null);
            }
            this.line1.push({
              id: id,
              path: new google.maps.Polyline({
                map: map,
                strokeColor: this.theme == "dark" ? "#991b1b" : "#EF4444",
                stokeOpacity: 0.5,
                strokeWeight: 2,
                geodesic: true,
                path: this.path,
              }),
            });
          }
        }
      });
    },

    checkTrackerPoint(id) {
      for (let i = 0; i < this.trackerpoint.length; i++) {
        if (id == this.trackerpoint[i].id) {
          return "checked";
        }
      }
      return "unchecked";
    },

    setControl() {
      const centerControlDiv = this.$refs.custom;
      this.$refs.mymap.$mapPromise.then((map) => {
        map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
          centerControlDiv
        );
      });
    },

    startIcon() {
      const icon = {
        path: "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
        fillColor: "blue",
        fillOpacity: 1,
        strokeColor: "#636363",
        strokeWeight: 0.5,
        rotation: 0,
        scale: 1.8,
        anchor: new google.maps.Point(0, 0),
      };
      return icon;
    },

    endIcon() {
      const icon = {
        path: "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
        fillColor: "green",
        fillOpacity: 1,
        strokeColor: "#636363",
        strokeWeight: 0.5,
        rotation: 0,
        scale: 1.8,
        anchor: new google.maps.Point(0, 0),
      };

      return icon;
    },

    getMalwareReports() {
      // console.log("ada detection");
      this.getDetectionMalware();
    },

    formatDateRange(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm:ss");
    },
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    this.setControl();
    this.getDetectionMalware();
    // this.trafficMode();
  },
};
</script>

<style scoped>
.badge {
  border-radius: 2%;
}
.text-black {
  color: #292929;
}
.maps {
  width: 100%;
  height: 580px;
}
.clusterMap .cluster img {
  object-fit: cover !important;
}
.custom-scroll::-webkit-scrollbar {
  width: 0px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* #mapsvg {
  animation: 1s ease-in-out alternate;
  animation:  1s ease-in infinite alternate;
} */
</style>
